import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-3 py-3 border-bottom border-top bg-light col-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Download pending domains", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "This will download all domains pending DNS Verification with CloudMailIn", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 py-3 row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "alert alert-warning",
      role: "alert"
    }, [
      /*#__PURE__*/_createElementVNode("em", { class: "font-bold not-italic" }, "Please note"),
      /*#__PURE__*/_createTextVNode(" newly added domains will take a minimum of 20 hours to verify.")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadPending && _ctx.downloadPending(...args)), ["prevent"]))
      }, " Download Pending Domains ")
    ]),
    _hoisted_4
  ]))
}